import { render } from "./MainInsuranceCompanies.vue?vue&type=template&id=c2a0b310&scoped=true"
import script from "./MainInsuranceCompanies.vue?vue&type=script&lang=js"
export * from "./MainInsuranceCompanies.vue?vue&type=script&lang=js"

import "./MainInsuranceCompanies.vue?vue&type=style&index=0&id=c2a0b310&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2a0b310"]])

export default __exports__